import { api, type OffsetPage } from '@/lib/api';

export type ConsoleNotificationKind =
  | 'report'
  | 'join_request'
  | 'billing'
  | 'sms_credits'
  | 'payment_connection'
  | 'campaign_delivery'
  | 'security'
  | 'other';

export interface ConsoleNotification {
  id: string;
  churchId: string;
  surface: 'console';
  kind: ConsoleNotificationKind;
  title: string;
  body: string;
  deepLink: string | null;
  sourceType: string | null;
  sourceId: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface ConsoleNotificationListResponse {
  data: ConsoleNotification[];
  page: OffsetPage;
  totals: { unreadCount: number };
}

export interface ConsoleNotificationWsPayload {
  surface: 'console';
  unreadCount: number;
  latest: Pick<ConsoleNotification, 'id' | 'kind' | 'title' | 'body' | 'deepLink' | 'createdAt'> | null;
}

export const consoleNotificationKeys = {
  all: ['console-notifications'] as const,
  unreadCount: () => [...consoleNotificationKeys.all, 'unread-count'] as const,
  list: (page: number, pageSize: number, unreadOnly: boolean) =>
    [...consoleNotificationKeys.all, 'list', page, pageSize, unreadOnly] as const,
};

export const fetchConsoleNotifications = (query: {
  page: number;
  pageSize: number;
  unreadOnly?: boolean;
}) =>
  api.get<ConsoleNotificationListResponse>('/notifications', {
    query: {
      page: query.page,
      pageSize: query.pageSize,
      unreadOnly: query.unreadOnly ? 'true' : undefined,
    },
  });

export const fetchConsoleUnreadCount = () =>
  api.get<{ unreadCount: number }>('/notifications/unread-count');

export const markConsoleNotificationsRead = (body: { notificationIds: string[] } | { readAll: true }) =>
  api.post<{ updatedCount: number; unreadCount: number }>('/notifications/read', body);
